import { useIntl } from '@/intl'
import { useGroupResponsibleStore } from '@/scopes/account/group-responsible/infrastructure/useGroupResponsibleStore'
import { tok, tokPx } from '@sunwebgroup/ui-components'
import { IconButton, Typography } from '@sunwebgroup/ui-components/uds'
import { styled } from 'styled-components'
import { getParticipantsEditingData } from '../selectors'

const ToolbarContainer = styled.div`
  position: fixed;
  bottom: ${tokPx('primitives_space_24')};
  left: 0;
  right: 0;
  width: fit-content;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: ${tokPx('primitives_space_6')};
  padding: ${tokPx('primitives_space_6')};
  background-color: ${tok('semantics_views_background_color')};
  border-radius: ${tokPx('primitives_corner_radius_xxl')};
  box-shadow: ${tok('primitives_box_shadows_level_5')};
`

const Divider = styled.div`
  width: ${tokPx('semantics_dividers_tickness')};
  align-self: stretch;
  border-radius: ${tokPx('primitives_corner_radius_full')};
  background-color: ${tok('semantics_dividers_color')};
`

const ToolBarItem = styled.div`
  padding: 0 ${tokPx('primitives_space_6')};
`

export function Toolbar() {
  const intl = useIntl()
  const { selectedCount, totalCount } = useGroupResponsibleStore(getParticipantsEditingData)
  const toggleIsEditingParticipants = useGroupResponsibleStore(state => state.toggleIsEditingParticipants)

  if (selectedCount === 0) {
    return null
  }

  return (
    <ToolbarContainer>
      <ToolBarItem>
        <Typography $variant="body-s-bold-tight">
          {intl.formatMessage(
            {
              id: 'groups_responsible_selected_count',
            },
            {
              selected: selectedCount,
              total: totalCount,
            },
          )}
        </Typography>
      </ToolBarItem>
      <Divider />
      <ToolBarItem>
        <IconButton
          glyph="Pencil"
          title={intl.formatMessage({ id: 'groups_responsible_edit_text' })}
          size="S"
          type="transparent-neutral"
          onClick={() => toggleIsEditingParticipants(true)}
        />
      </ToolBarItem>
    </ToolbarContainer>
  )
}
